import React from 'react'
import { useTranslation } from 'react-i18next'
import LeftContact from '../Components/Contact/LeftContact'
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';

const Contacts = () => {
   const {t} = useTranslation();
   const {contextSafe} = useGSAP(()=>{
             const safetwen =  contextSafe(()=>{
                gsap.from(".Contact",{
            duration: 1.3,
            delay:0.1,
            scale:1,
            y: -100,
            filter:"blur(7px)",
            opacity: 0,

          })
               })
               safetwen()
      },[])
  return (
    <div className='bg-[#091c30]  dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700'>
     <section className='flex justify-center Contact'>
        <LeftContact/>
     </section>
    </div>
  )
}

export default Contacts
